<template>
  <v-card>
    <v-card-title>Events (Order n°{{ pipelineEvent.number }})</v-card-title>
    <v-divider></v-divider>
    <EventDescriptionHeaders :pipeline-event="pipelineEvent" />
    <v-divider></v-divider>
    <v-card-text style="max-height: 700px;">
      <div v-if="pipelineEvent && pipelineEvent.events.length > 0">
        <EventCard
          v-for="event in pipelineEvent.events"
          :key="event.timestamp"
          :event="event"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import EventDescriptionHeaders from "./EventDescriptionHeaders.vue";
import EventCard from "./EventCard.vue";

export default {
  components: { EventDescriptionHeaders, EventCard },
  props: {
    pipelineEvent: { type: Object },
  },
};
</script>
